import type { Match } from "navigo";
import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import type { Route, RouteContext } from "../router";
import { centeredBox } from "../van/centered-box";
import { button, div, h1, input, label, p } from "../van/van-tags";

export class Sp2ProvisioningPage implements Route {
	#onClickCopy(): void {
		navigator.clipboard
			.writeText(this.#reactive.mqttPassword)
			.then(() => {
				this.#reactive.helpStatus = "is-success";
				this.#reactive.helpText = "Copied to clipboard";
			})
			.catch(() => {
				this.#reactive.helpStatus = "is-danger";
				this.#reactive.helpText = "Copy failed";
			});
	}

	async #provision(): Promise<void> {
		this.#reactive.helpText = "";

		const req = this.#ctx.api.put(
			`/smartplug2s/${this.#reactive.imei}/provision`,
		);
		req.setSignedInUserAuth();

		const res = await req.do();
		if (res.ok) {
			this.#reactive.mqttPassword = await res.json();
		} else {
			this.#reactive.helpStatus = "is-danger";
			this.#reactive.helpText = `${res.status}: ${await res.text()}`;
		}
	}

	async refresh(match: Match): Promise<void> {
		if (!match?.data?.imei) throw "missing path param: imei";
		this.#reactive.imei = match.data.imei;
		await this.#provision();
	}

	#ctx: RouteContext;
	#reactive = reactive({
		helpStatus: "",
		helpText: "",
		imei: "",
		mqttPassword: "",
	});

	ChildDom: ChildDom;

	constructor(ctx: RouteContext) {
		this.#ctx = ctx;
		this.ChildDom = centeredBox(
			{ size: "narrow" },
			h1({ class: "title is-4" }, () => this.#reactive.imei),
			p({ class: "subtitle is-6" }, "SmartPlug2"),
			p(
				{ class: () => `help ${this.#reactive.helpStatus}` },
				() => this.#reactive.helpText,
			),
			div(
				{ class: "field" },
				label({ class: "label" }, "Assigned MQTT password"),
				div(
					{ class: "field has-addons" },
					div(
						{ class: "control is-expanded" },
						input({
							class: "input",
							disabled: true,
							type: "text",
							value: () => this.#reactive.mqttPassword,
						}),
					),
					div(
						{ class: "control" },
						button(
							{
								class: "button is-primary",
								disabled: () =>
									this.#reactive.mqttPassword === "",
								onclick: () => this.#onClickCopy(),
							},
							"Copy",
						),
					),
				),
			),
			div(
				{ class: "buttons" },
				button(
					{
						class: "button is-primary is-fullwidth",
						onclick: () =>
							this.#ctx.router.jump(
								`/smartplug2/${this.#reactive.imei}/test`,
							),
					},
					"Test",
				),
				button(
					{
						class: "button is-primary is-fullwidth",
						onclick: () =>
							this.#ctx.router.jump("/factory/smartplug2"),
					},
					"Back",
				),
			),
		);
	}
}
